import React, { useState, useRef } from 'react'
import Select from 'react-select'

export const SelectContentSearchinput = ({
  id = '',
  value,
  setValue,
  field = null,
  disabled = false,
  required = false,
  options = [],
  placeholder = 'Selecione uma opção...',
  styleControl = {},
  limitOptions = 20,
}) => {
  const [searchTerm, setSearchTerm] = useState('')
  const [highlightedOption, setHighlightedOption] = useState(null)
  const selectRef = useRef(null) // Ref do Select

  const filteredOptions = options
    .filter((option) => option.label.toLowerCase().includes(searchTerm.toLowerCase()))
    .slice(0, limitOptions)

  const changeValue = (newValue) => {
    if (!newValue) return
    if (field) {
      setValue({ ...value, [field]: newValue.value })
    } else {
      setValue(newValue.value)
    }
    setSearchTerm(newValue.label || newValue.value)
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      if (highlightedOption) {
        changeValue(highlightedOption)
      } else if (searchTerm.trim() !== '') {
        const newOption = { label: searchTerm, value: searchTerm }
        changeValue(newOption)
      }

      // Fecha o menu e tira o foco do input
      if (selectRef.current) {
        selectRef.current.blur()
      }
    }
  }

  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: '50px',
      borderColor: '#dbdbdb',
      padding: '0.25rem 0.735rem',
      height: '42px',
      fontSize: '14px',
      boxShadow: 'none',
      ...styleControl,
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 999,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#3273dc' : 'white',
      color: state.isFocused ? 'white' : '#363636',
      fontSize: '14px',
    }),
  }

  const optionValue = () => {
    let v
    if (field) {
      v = options.find((opt) => opt.value === value[field])
      if (!v && value[field]) {
        v = { label: value[field], value: value[field] }
      }
    } else {
      v = options.find((opt) => opt.value === value)
      if (!v && value) {
        v = { label: value, value }
      }
    }
    return v || null
  }

  return (
    <Select
      ref={selectRef}
      id={id}
      options={filteredOptions}
      value={optionValue()}
      onChange={changeValue}
      onInputChange={(inputValue) => setSearchTerm(inputValue)}
      onKeyDown={handleKeyDown}
      placeholder={placeholder}
      isSearchable={true}
      disabled={disabled}
      required={required}
      styles={customStyles}
      onFocus={() => setHighlightedOption(null)}
      onMenuHighlight={(option) => setHighlightedOption(option)}
      noOptionsMessage={() => 'Digite para criar ou selecione uma opção'}
    />
  )
}
